import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const cached = localStorage.getItem('user_info');
      return cached ? JSON.parse(cached) : null;
    } catch (e) {
      return null;
    }
  });
  const [plants, setPlants] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    try {
      const res = await api.get('/auth/me/');
      const uData = { authenticated: true, ...res.data };
      setUser(uData);
      localStorage.setItem('user_info', JSON.stringify(uData));
    } catch (err) {
      setUser({ authenticated: true });
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      setLoading(true);
      fetchProfile().finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginUser = (access, refresh, userData = null) => {
    localStorage.setItem('access_token', access);
    localStorage.setItem('refresh_token', refresh);
    if (userData) {
      const uData = { authenticated: true, ...userData };
      setUser(uData);
      localStorage.setItem('user_info', JSON.stringify(uData));
    } else {
      fetchProfile();
    }
  };

  const logout = () => { localStorage.clear(); setUser(null); setPlants([]); };

  return (
    <AuthContext.Provider value={{ user, plants, loading, loginUser, logout, fetchProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
